module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-quiz_gray.2699abb4.svg";